import React, {useState,useEffect} from "react";
import './Phone.css';
import ContainPhone  from './ContainPhone/ContainPhone';

export default function Phone() {
  const [CurrentIdName, setCurrentIdName] = useState("")
  const [contain, setContain] = useState("Enroll")

  useEffect(()=>{
    document.getElementById("Enroll").style.visibility = "hidden";
    setCurrentIdName("Enroll");
    //setContain("Enroll")
  },[])

  const click_ =(id_name)=>{
    document.getElementById(CurrentIdName).style.visibility = "visible";
    document.getElementById(id_name).style.visibility = "hidden";
    setCurrentIdName(id_name);
    setContain(id_name);
  }

  return (
    <div>
        <div className="Phone-title">
          <h1>Playgrounds</h1>
        </div>

        <div className="Phone-quick">

          <div className="Phone-display">
          <div id="Enroll_"><h3>Enroll</h3><h2>注册</h2> </div>
          <div id="Login_"><h3>Login</h3><h2>登入</h2> </div>
          <div id="Puzzle_"><h3>Puzzle</h3><h2>华容道</h2></div>
          </div>

          <div className="Phone-button">
          <div id="Enroll" onClick={()=>click_("Enroll")}><h3>Enroll</h3><h2>注册</h2> </div>
          <div id="Login" onClick={()=>click_("Login")}><h3>Login</h3><h2>登入</h2> </div>
          <div id="Puzzle" onClick={()=>click_("Puzzle")}><h3>Puzzle</h3><h2>华容道</h2></div>
          </div>

        </div>

        <div className="Phone-contain">
            <ContainPhone 
            ContainInfo = {contain}/>
        </div>

    </div>
  );
}

